export enum OverreadFeedbackStatus {
  ABSTRACTOR = "Abstractor review",
  MANAGER = "Manager review",
  COMPLETED = "Completed",
  REQUESTED = "Requested",
  REQUESTEDNOTREQUIRED = "RequestedNotRequired",
  RECEIVED = "Received",
}
